import en from "./en";
import kz from "./kz";

export const resources = {
  en: { translation: en },
  kz: { translation: kz },
} as const;

const savedLanguage = localStorage.getItem("language") || "en";

export const selectedLanguage = savedLanguage;

export const setLanguage = (language: string) => {
  localStorage.setItem("language", language);
  window.location.reload();
};

export default resources;
